import { useLocation } from 'react-router-dom';
import { Box } from '@chakra-ui/react';

import HeaderMobile from 'Component/header-mobile';
import { Condition } from 'Component/others';
import checkPublicRoute from 'Helper/checkPublicRoute';
import useGetHostSummary from 'Domain/host/useGetHostSummary';
import useGetHostUpcomingScheduleOverview from 'Domain/host/useGetHostUpcomingScheduleOverview';
import useGetPresences from 'Domain/host-attendance-record/useGetPresences';

import HostProvider from 'View/host/state';
import HostDashboardMenu from 'View/host/section/host-dashboard-menu';
import ScheduleOverview from 'View/host/section/schedule-overview';
import AttendanceOverview from 'View/host/section/attendance-overview';
import AttendanceOverviewContent from 'View/host/component/attendance-overview-content';
import { SkeletonHostAttendance, SkeletonHostOverview, SkeletonHostSchedule } from 'View/host/component/skeleton';

import styles from './styles.module.css';

const Host = () => {
  const { pathname } = useLocation();
  const isPublic = checkPublicRoute(pathname);

  const { data, isLoading: isLoadingSummary } = useGetHostSummary();
  const { isLoading: isLoadingUpcoming } = useGetHostUpcomingScheduleOverview();
  const { data: presenceData, isLoading: isLoadingPresence } = useGetPresences({ isPublic });

  const { clockInTime } = presenceData ?? {};

  return (
    <Box className={styles['host__container']}>
      <HeaderMobile />
      <Box className={styles['host-livestream__container']}>
        <Condition statement={!isLoadingPresence} fallback={<SkeletonHostAttendance />}>
          <Box className={styles['host-attendance-overview__container']}>
            <AttendanceOverview presenceData={presenceData}>
              <AttendanceOverviewContent clockInTime={clockInTime} />
            </AttendanceOverview>
          </Box>
        </Condition>
        <Condition statement={!isLoadingSummary} fallback={<SkeletonHostOverview />}>
          <Box className={styles['host-live-overview__container']}>
            <HostDashboardMenu data={data} isFetching={isLoadingSummary} />
          </Box>
        </Condition>

        <Condition statement={!isLoadingUpcoming} fallback={<SkeletonHostSchedule />}>
          <Box className={styles['host-schedule-overview__container']}>
            <ScheduleOverview />
          </Box>
        </Condition>
      </Box>
    </Box>
  );
};

const HostContainer = () => <HostProvider children={<Host />} />;

export default HostContainer;
